import { evalQueries } from '@/entities/eval';
import { useEvaluationStore } from '@/entities/eval/model/eval-stnt.store';
import { publishQueries, publishUserQueries } from '@/entities/sets/publish';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { useToastStore } from '@/shared/lib/store/model/toast.store';
import { ErrorPopup, Icon } from '@/shared/ui';
import { EvalPasswordReset } from '@/widgets/eval/ui/eval-password-reset';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { ReactNode, useEffect, useState } from 'react';
import { EvalInfoTable } from '@/widgets/eval';
import { useReportStore } from '@/entities/report';
import { useLoginStore } from '@/shared/lib/store/model/login.store';
import { decryptDataDeterministic } from '@/shared/utils/publish';
import { sendTraceLog } from '@/shared/log/tracker';
import { usePersistStore } from '@/shared/lib/store';

export const Route = createFileRoute('/eval/')({
    component: RouteComponent,
    //   loader: ({ params }) => {
    //     return { taskId: params.taskId, claId: params.claId }
    //   },
});

function RouteComponent() {
    const { setNickNameToken } = useLoginStore();
    const SECRET_KEY = import.meta.env.VITE_TTUK_URL_DATA_KEY;
    // const { taskId, claId } = Route.useLoaderData()
    const [nickName, setNickNameValue] = useState('');
    const [tcUserId, setTcuserId] = useState('');
    const [claId, setClaId] = useState('');
    const [encodeName, setEncodeName] = useState('');
    const [userPw, setUserPw] = useState('');
    const [isPdShow, setIsPdShow] = useState(true);
    const [isPwReset, setIsPwReset] = useState(false);
    const [title, setTitle] = useState('');
    const [evalDetail, setEvalDetail] = useState<API.STNT.EvalInfoTch.Res>();
    const [isStart, setIsStart] = useState<boolean>(true);
    const [token, setToken] = useState<string>('');
    const [usage, setUsage] = useState<number>(0);

    const { setStntReport } = useReportStore();
    const { showModal } = useModalStore();
    const { showToast } = useToastStore();
    const { publishInfo, sUserId, setPublishInfo, setSUserId, setSUserNickName, setVivaTcUserId } =
        useEvaluationStore();
    const { setPersistSUserId, setPersistSDefaultUserId } = usePersistStore();
    const router = useRouter();
    const timestamp = Date.now();
    //회원 정보 등록
    const registerStudent = publishUserQueries.postRegisterUser();
    //과제에 학생 추가
    const addStdt = publishQueries.detail.postIntegPubAddStdt();
    //닉네임/비번 인증
    const nickNameData = publishQueries.publish.postNickNameAuth();

    const { refetch } = publishQueries.publish.getIntPubStdtByNickName({
        publishId: publishInfo.publishId,
        nickNm: nickName,
    });

    const { refetch: refetchTch } = evalQueries.getEvalInfoTch(
        { evlId: publishInfo.trgtId },
        false
    );

    useEffect(() => {
        async function fetchAndSetUser() {
            await setNickNameToken(sUserId);

            const parsedToken = JSON.parse(sessionStorage.getItem('persist-token')!);
            setToken(parsedToken?.state?.sToken);
        }
        fetchAndSetUser();
    }, []);

    useEffect(() => {
        sessionStorage.setItem('evalUserInfo', JSON.stringify({ evlId: 0, userId: '' }));
        fnDecryptedData();
    }, [token]);

    const fnDecryptedData = () => {
        // 1) #fragment 우선
        let enc = window.location.hash ? window.location.hash.substring(1) : '';

        // 2) 없으면 /eval/$ENCODED 경로 확인
        if (!enc) {
            const match = window.location.pathname.match(/\/eval\/\$([^/]+)/);
            if (match) enc = match[1];
        }

        if (!enc) return;

        try {
            const decrypted = decryptDataDeterministic(enc);
            setPublishInfo({ publishId: decrypted.taskId, trgtId: decrypted.trgtId });
            setStntReport({ usage: decrypted.publishType === 1 ? '클래스' : 'URL' });
            setTcuserId(decrypted.tcUserId);
            setVivaTcUserId(
                decrypted.tcUserId?.split('-')[0] === 'viva'
                    ? decrypted.tcUserId
                    : 'viva-' + decrypted.tcUserId + '-t'
            );
            setClaId(decrypted.claId);
            setUsage(decrypted.publishType);
        } catch (e) {
            console.error('복호화 실패:', e);
        }
    };

    useEffect(() => {
        if (token) {
            const fetchData = async () => {
                const resultData = await refetchTch();
                const info = resultData.data;
                if (info) {
                    setTitle(info.evlNm);
                    setEvalDetail(info);
                }
            };

            if (publishInfo.trgtId != 0) {
                fetchData();
            }
        }
    }, [publishInfo.trgtId, token]);

    useEffect(() => {
        if (evalDetail) {
            if (new Date(evalDetail.evlPrgDt) > new Date()) {
                setIsStart(new Date(evalDetail.evlPrgDt) < new Date());
            }
        }
    }, [evalDetail]);

    const getNickNameCheck = async () => {
        var setUserId = '';

        const { data: latestData } = await refetch();
        const data = latestData?.studentInfo;

        const isViva = tcUserId?.split('-')[0] === 'viva';
        if (data.length > 0) {
            setUserId = data[0].stdtUserId;
        } else {
            setUserId = `${isViva ? tcUserId?.split('-')[1] : tcUserId}_${publishInfo.publishId}_${timestamp}`;
        }

        const tchId = isViva ? tcUserId : 'viva-' + tcUserId + '-t';
        var info = {
            tcUserId: tchId,
            claList: [
                {
                    claId: claId,
                    stdtUserInfo: [{ stdtUserId: setUserId, nickNm: nickName }],
                },
            ],
        };
        if (usage === 2) {
            setPersistSDefaultUserId(tcUserId);
            setPersistSUserId(tchId);
        }

        setSUserId(setUserId);
        setSUserNickName(nickName);
        sendTraceLog(
            '',
            '',
            '',
            'debug',
            '[SBANK_LOG] savePublish setUserId =',
            setUserId,
            'nickName = ',
            nickName
        );
        onRegister(info);
    };

    const showErrorModal = () => {
        showModal({
            isCustom: true,
            id: 'error',
            initContents: () => <ErrorPopup />,
        });
    };

    const showToastMessage = (message: ReactNode, type: ToastType) => {
        showToast(message, 2000, type);
    };
    const [idCheck, setIdCheck] = useState<boolean>(false);
    const [pwCheck, setPwCheck] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setNickNameValue(value);
        setIdCheck(false);
        if (value.length < 1) {
            setErrorMessage('닉네임은 최소 1글자 이상 입력해야 합니다.');
        } else if (value.length > 10) {
            setErrorMessage('닉네임은 최대 10글자까지 입력할 수 있습니다.');
        } else if (/\s/.test(value)) {
            setErrorMessage('띄어쓰기를 입력할 수 없습니다.');
        } else if (/[^a-zA-Z0-9가-힣\s]/.test(value)) {
            setErrorMessage('~!@와 같은 특수문자를 입력할 수 없습니다.');
        } else {
            setIdCheck(true);
            setErrorMessage('');
            setEncodeName(encodeToUTF8(value.replace(/[^a-zA-Z0-9가-힣]/g, '')));
        }
    };

    //닉네임 base64인코딩
    const encodeToUTF8 = (text: string): string => {
        return btoa(unescape(encodeURIComponent(text)));
    };

    //비밀번호 숫자만
    const handleChangePw = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setPwCheck(false);
        if (/^\d*$/.test(inputValue)) {
            if (event.target.value.length < 4 || event.target.value.length > 4) {
            } else {
                setPwCheck(true);
            }

            // 숫자만 허용 (정규식)
            setUserPw(inputValue);
        }
    };

    const enterEval = async () => {
        if (!nickName || !encodeName || !userPw) {
            showToastMessage(<p className="txt-s">닉네임과 비밀번호를 입력해 주세요.</p>, 'error');
        } else {
            await getNickNameCheck();
        }
    };

    const onRegister = async (dClassInfo: any) => {
        registerStudent.mutate(dClassInfo, {
            onSuccess: async (res) => {
                sendTraceLog('', '', '', 'debug', 'registerStudent res = ', res);
                if (res?.resultOk) {
                    await setNickNameToken(dClassInfo.claList[0].stdtUserInfo[0].stdtUserId);
                    checkNicknameAuth(dClassInfo.claList[0].stdtUserInfo[0].stdtUserId);
                } else
                    showToastMessage(
                        <p className="txt-s">{res?.resultMsg ? res?.resultMsg : ''}</p>,
                        'error'
                    );
            },
            onError: () => showErrorModal(),
        });
    };
    const checkNicknameAuth = async (userId: string) => {
        nickNameData.mutate(
            {
                publishId: publishInfo.publishId,
                stdtUserId: userId,
                pwd: userPw,
            },
            {
                onSuccess: (res) => {
                    if (res?.resultOk) {
                        addEvalStdt(res?.resultCd == '0000' ? false : true, userId);
                        setIsPwReset(res?.resultCd == '0000' ? false : true);
                    } else {
                        showToastMessage(
                            <p className="txt-s">{res?.resultMsg ? res?.resultMsg : ''}</p>,
                            'error'
                        );
                    }
                },
                onError: () => showErrorModal(),
            }
        );
    };

    const addEvalStdt = async (PwReset: boolean, userId: string) => {
        var stdId = [];
        stdId.push();

        addStdt.mutate(
            {
                stdtUserIds: [userId],
                publishId: publishInfo.publishId,
            },
            {
                onSuccess: (res) => {
                    const { resultData, paramData } = res || {};
                    if (resultData?.resultCd == '0000' || resultData?.resultCd == '0001') {
                        sessionStorage.setItem(
                            'evalUserInfo',
                            JSON.stringify({
                                publishId: publishInfo.publishId,
                                evlId: paramData.trgtId,
                                userId: paramData.stdtUserIds[0],
                            })
                        );

                        if (!PwReset) goReadyPage();
                    } else
                        showToastMessage(
                            <p className="txt-s">
                                {resultData?.resultMsg ? resultData?.resultMsg : ''}
                            </p>,
                            'error'
                        );
                },
                onError: () => showErrorModal(),
            }
        );
    };

    const goReadyPage = () => {
        // sessionStorage.setItem('evalUserInfo', JSON.stringify({ evlId: trgtId, userId: userId }));
        router.navigate({ to: '/eval/ready' });
    };

    useEffect(() => {
        setUserPw('');
        setNickNameValue('');
    }, [isPwReset]);

    return (
        // <div>
        //   <h1>Task ID: {taskId}</h1>
        //   <h3>Cla ID: {claId}</h3>
        // </div>
        <div>
            {evalDetail && !isStart && (
                <EvalInfoTable
                    data={evalDetail ?? {}}
                    showBtn={false}
                    publishId={publishInfo.publishId}
                />
            )}
            {evalDetail && isStart && (
                <>
                    {!isPwReset && (
                        // 학생 응시 화면 모바일 최적화 클래스 추가 25.04.15
                        <div className="con-layout layout-style1 mobile">
                            <p className="txt-style4">{title}</p>

                            <div className="base-box box-style1 box-pd1 con-mt3">
                                <ul>
                                    <li className="bul-item2">
                                        이 평가에 처음 접속한다면, 내가 사용할 닉네임과 비밀번호를
                                        직접 설정해 주세요.
                                    </li>
                                    <li className="bul-item2">
                                        닉네임에 실명을 사용하지 않도록 주의해 주세요.
                                    </li>
                                    <li className="bul-item2">
                                        다시 접속할 땐 내가 설정했던 닉네임과 비밀번호로 입력해
                                        주세요.
                                    </li>
                                    <li className="bul-item2 txt_red">
                                        비밀번호를 잊어버렸다면 선생님께 초기화를 요청해 주세요.
                                    </li>
                                </ul>
                            </div>

                            <div className="con-mt4">
                                <div className="form-row2">
                                    <div className="form-label2">닉네임</div>
                                    <div className="form-td">
                                        <div className="textbox">
                                            <input
                                                type="text"
                                                className="input-txt input-style2"
                                                value={nickName}
                                                maxLength={10}
                                                onChange={handleChange}
                                                placeholder="닉네임을 입력하세요. (최대 10글자)"
                                            />
                                            <button
                                                type="button"
                                                className="textbox__btn"
                                                onClick={() => setNickNameValue('')}
                                            >
                                                <Icon icon="del2" txt="삭제" />
                                            </button>
                                        </div>
                                        <p className="form-summary">{errorMessage}</p>
                                    </div>
                                </div>

                                <div className="form-row2">
                                    <div className="form-label2">비밀번호</div>
                                    <div className="form-td">
                                        <div
                                            className={`textbox ${isPdShow ? 'isPdShow pdb10' : ''}`}
                                        >
                                            <input
                                                type={`${isPdShow ? 'password' : 'text'}`}
                                                onChange={handleChangePw}
                                                value={userPw}
                                                className="input-txt input-style2"
                                                maxLength={4}
                                                placeholder="재입장할 때 사용할 나만의 비밀번호를 입력하세요. (숫자 4자리)"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        enterEval(); // 엔터키가 눌리면 enterEval 실행
                                                    }
                                                }}
                                            />
                                            <button
                                                type="button"
                                                className="textbox__btn"
                                                onClick={() => {
                                                    setIsPdShow(!isPdShow);
                                                }}
                                            >
                                                <Icon icon="pd-show" txt="비밀번호 보기" />
                                            </button>
                                        </div>
                                        {userPw.length > 4 && (
                                            <p className="form-summary">
                                                비밀번호는 숫자 4자리까지 입력할 수 있습니다.
                                            </p>
                                        )}
                                        <p className="mt20 txt_blue ft14">
                                            * 처음 입장할 때 사용한 닉네임, 비밀번호를 입력해야
                                            재입장할 수 있으니 꼭 기억해 주세요.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="btn-wrap btn-width2 con-mt4">
                                {/* <button type="button" className="btn btn-default line lg2">
                                    <Icon icon="out" />
                                    나가기
                                </button> */}
                                <button
                                    type="button"
                                    className="btn btn-default blue lg2"
                                    disabled={!(idCheck === true && pwCheck === true)}
                                    onClick={enterEval}
                                >
                                    입장하기
                                </button>
                            </div>
                        </div>
                    )}
                    {isPwReset && (
                        <EvalPasswordReset isPwResetProps={setIsPwReset}></EvalPasswordReset>
                    )}
                </>
            )}
        </div>
    );
}
